import { css } from 'react-emotion';
import themeConfig from '@lyearn-team/theme-config';

const container = () => css`
  margin-top: -64px;
`;

const root = () => css`
  text-align: center;
  width: 428px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;
  margin-bottom: 160px;
  position: relative;
`;

const logoImage = () => css`
  max-width: 114px;
`;

const title = () => css`
  font-size: 24px;
  text-align: center;
  color: ${themeConfig.color.dark.copper};
  margin-bottom: 5px;
`;

const subTitle = () => css`
  font-size: 16px;
  text-align: center;
  color: #8392a7;
  margin-bottom: 40px;
`;

const inputStyle = () => css`
  background: #fff !important;
`;

const disabledInputStyle = () => css`
  background: #f0f1f4 !important;
`;

const doneButton = css`
  padding: 12px 76px;
  font-size: 16px;
`;

const continueButton = isDisabled => css`
  outline: none;
  width: 202px;
  height: 48px;
  font-size: 1.3em;
  line-height: 48px;
  letter-spacing: 0.8px;
  position: relative;
  font-family: 'ProximaNova';
  border: 0px;
  background: ${isDisabled ? '#929dae' : '#00b5ff'};
  border-radius: 100px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.13);
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.13);
  -moz-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.13);
  cursor: ${isDisabled ? 'no-drop' : 'pointer'};
  text-transform: uppercase;
  color: white;
  padding: 0px;
  transition: all 0.15s linear;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-align: center;
  color: #ffffff;

  &:hover {
    background: ${isDisabled ? '#929dae' : '#009CEE'};
  }
`;

const inputLabel = () => css`
  font-size: 12px;
  letter-spacing: 0.9px;
  text-align: left;
  color: #929dae;
  text-transform: uppercase;
  text-align: left;
  display: inline-block;
  width: 100%;
`;

const checkboxStyle = () => css`
  margin-bottom: 20px;
`;

const flexRow = () => css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const innerPageHeader = () => css`
  padding-top: 27px;
  padding-left: 44px;
`;

const innerPageFooter = () => css`
  position: fixed;
  left: 0px;
  bottom: 0px;
  height: 60px;
  background: rgba(224, 233, 240, 0.44);
  font-size: 1.6em;
  line-height: 20px;
  color: #606c7a;
  padding: 0 44px;
  box-sizing: border-box;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-direction: row;
`;

const footerText = () => css`
  padding: 0px;
  margin: 0px;
  font-weight: 300;
  line-height: 20px;
  font-size: 16px;
  color: rgba(131, 146, 167, 0.7);
`;

const footerHoverText = () => css`
  &:hover {
    color: rgb(131, 146, 167);
  }
`;

const footerAppleIcon = () => css`
  margin: 0 18px 0 11px;
  color: rgba(131, 146, 167, 0.7);
  font-size: 24px;
  transition: all 0.1s linear;
`;

const footerAndroidIcon = () => css`
  color: rgba(131, 146, 167, 0.7);
  font-size: 24px;
  transition: all 0.1s linear;
`;

const inputWrapper = () => css`
  margin-bottom: 20px;
`;

const checkBoxWrapper = css`
  display: flex;
  align-items: center;
  color: ${themeConfig.color.dark.copper};
`;

export default {
  container,
  root,
  title,
  subTitle,
  inputStyle,
  continueButton,
  doneButton,
  checkboxStyle,
  inputLabel,
  flexRow,
  logoImage,
  innerPageHeader,
  innerPageFooter,
  footerAppleIcon,
  footerAndroidIcon,
  footerText,
  footerHoverText,
  inputWrapper,
  disabledInputStyle,
  checkBoxWrapper
};
